import { useSession } from '../runtime';
function isNil(value) {
    return value == null || typeof value === 'undefined' || value === undefined;
}
export function useIsAuthenticated() {
    const session = useSession();
    return !isNil(session);
}
